<template>
  <v-form
    ref="itemsform"
    lazy-validation
  >
    <v-text-field
      v-model="editedItem.sql_server_name"
      label="SQL Server Name"
      outlined
      :rules="[rules.required]"
    />
    <v-text-field
      v-model="editedItem.sql_server_ip"
      label="SQL Server IP"
      outlined
      :rules="[rules.required]"
    />
    <v-select
      v-model="editedItem.region_id"
      :items="regions"
      item-text="region_short"
      item-value="region_id"
      label="Region"
    />
    <v-switch
      v-model="editedItem.primary_server"
      label="Primary Server"
      true-value="y"
      false-value="n"
    />
  </v-form>
</template>
<script>
  export default {
    name: 'sqlserverForm',
    props: {
      editedItem: Object,
      regions: Array
    },
    data () {
      return {
        rules: {
          required: value => !!value || 'Required.',
        },
      }
    },
  }
</script>